var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_c('router-link',{staticClass:"logo",attrs:{"to":"/home"}},[_c('Logo',{attrs:{"alt":"Wimble"}})],1),(_vm.currentUser)?_c('button',{on:{"click":_vm.signOut}},[_vm._v("Sign Out")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }